import React from 'react'
import { type DropdownIndicatorProps } from 'react-select'

import { Icon } from '../../../../module'
import styles from '../_select.module.scss'

const DropdownIndicator = <OptionType,>(
  props: DropdownIndicatorProps<OptionType>,
) => {
  const { isDisabled, selectProps } = props,
    { menuIsOpen, noBorder } = selectProps
  return (
    <Icon
      icon='carat'
      iconSize='8px'
      color={isDisabled ? 'gray' : 'purple'}
      className={`${styles.icon} ${menuIsOpen ? styles.iconOpen : ''} ${noBorder ? styles.noBorder : ''}`}
    />
  )
}

export default DropdownIndicator
